import { TODO, UIBModal } from '@b2b/types/core';
import angular, { IScope } from 'angular';
import { InventoryItem } from '../types';

class InventoryRemoveModalController {
  static $inject = ['$scope', '$uibModalInstance', 'currentInventory'];

  errors: Array<{ message: string }> = [];
  model = {
    name: this.currentInventory?.name ?? '',
  };

  constructor(
    private $scope: IScope,
    private $uibModalInstance: UIBModal<true>,
    private currentInventory: InventoryItem | null
  ) {}

  hasErrors() {
    return this.errors.length > 0;
  }

  done() {
    this.success();
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  success() {
    this.$uibModalInstance.close(true);
  }
}

export const InventoryRemoveModalControllerModule = angular
  .module('acme.view.application.inventory.removeModal.controllers', [])
  .controller('InventoryRemoveModalController', InventoryRemoveModalController).name;
